import ControlledSelect from "components/inputs/Select/ControlledSelect";
import { ControlledInput } from "components/Card/ControlledInput";

import Card from "components/Card/Card";
import { MaskedInput, TextInput } from "components/inputs";
import type { FormData } from "../shared/IntakeTypes";
import { useFormContext } from "react-hook-form";
import { STATES } from "../shared/IntakeConstants";

type EmployerIntakeFormProps = {
  handleFieldChange: (
    field: string,
    value: string | number | boolean | Array<{ value: string; label: string }>,
  ) => Promise<void>;
};

const EmployerIntakeForm = ({ handleFieldChange }: EmployerIntakeFormProps) => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<FormData>();

  return (
    <div>
      <Card
        heading="Employer Information"
        cardNumber={3}
        style={{ columnSpan: "all" }}
      >
        <ControlledInput
          control={control}
          name="employerName"
          label="Employer Name"
          errors={errors}
          maxLength={100}
          onSave={(value) => handleFieldChange("employerName", value)}
          componentType={TextInput}
        />

        <ControlledInput
          control={control}
          name="employerAddress"
          label="Address"
          errors={errors}
          maxLength={100}
          onSave={(value) => handleFieldChange("employerAddress", value)}
          componentType={TextInput}
        />

        <ControlledSelect<FormData>
          control={control}
          name="employerState"
          label="State"
          errors={errors}
          options={STATES}
          onSave={async (option) => {
            if (option) {
              setValue("employerState", String(option.value));
              await handleFieldChange("employerState", option.value);
            }
          }}
        />

        <ControlledInput
          control={control}
          name="employerZipCode"
          label="Zip Code"
          errors={errors}
          onSave={(value) => handleFieldChange("employerZipCode", value)}
          componentType={MaskedInput}
          mask="zipcode"
        />
      </Card>
      <Card
        heading="Insurer Information"
        cardNumber={3}
        style={{ columnSpan: "all" }}
      >
        <ControlledInput
          control={control}
          name="insurerName"
          label="Name"
          errors={errors}
          maxLength={100}
          onSave={(value) => handleFieldChange("insurerName", value)}
          componentType={TextInput}
        />

        <ControlledInput
          control={control}
          name="insurerAddress"
          label="Address"
          errors={errors}
          maxLength={100}
          onSave={(value) => handleFieldChange("insurerAddress", value)}
          componentType={TextInput}
        />

        <ControlledSelect<FormData>
          control={control}
          name="insurerState"
          label="State"
          errors={errors}
          options={STATES}
          onSave={async (option) => {
            if (option) {
              setValue("insurerState", String(option.value));
              await handleFieldChange("insurerState", option.value);
            }
          }}
        />

        <ControlledInput
          control={control}
          name="insurerZipCode"
          label="Zip Code"
          errors={errors}
          maxLength={10}
          onSave={(value) => handleFieldChange("insurerZipCode", value)}
          componentType={MaskedInput}
          mask="zipcode"
        />
      </Card>
      <Card
        heading="TPA Information"
        cardNumber={3}
        style={{ columnSpan: "all" }}
      >
        <ControlledInput
          control={control}
          name="tpaName"
          label="Name"
          errors={errors}
          maxLength={100}
          onSave={(value) => handleFieldChange("tpaName", value)}
          componentType={TextInput}
        />

        <ControlledInput
          control={control}
          name="tpaAddress"
          label="Address"
          errors={errors}
          maxLength={100}
          onSave={(value) => handleFieldChange("tpaAddress", value)}
          componentType={TextInput}
        />

        <ControlledSelect<FormData>
          control={control}
          name="tpaState"
          label="State"
          errors={errors}
          options={STATES}
          onSave={async (option) => {
            if (option) {
              setValue("tpaState", String(option.value));
              await handleFieldChange("tpaState", option.value);
            }
          }}
        />

        <ControlledInput
          control={control}
          name="tpaZipCode"
          label="Zip Code"
          errors={errors}
          maxLength={10}
          onSave={(value) => handleFieldChange("tpaZipCode", value)}
          componentType={MaskedInput}
          mask="zipcode"
        />
      </Card>
    </div>
  );
};

export default EmployerIntakeForm;
